export default __webpack_public_path__ + "static/media/joinClose.b5771341.svg";